<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >
    <div class="devisLinesShell">
      <div class="devisLinesHeader">
        <div>
          <div class="devisLinesEyebrow">Edition rapide</div>
          <div class="devisLinesTitle">Lignes ajoutees</div>
        </div>
        <div class="devisLinesCount">{{ lineCountLabel }}</div>
      </div>

      <div v-if="safeItems.length === 0" class="devisEmptyState">
        <b-icon icon="bag-plus" font-scale="1.6"></b-icon>
        <div>
          <div class="devisEmptyTitle">Aucune ligne pour le moment</div>
          <div class="devisEmptyText">
            Ajoutez un produit ou un service depuis le catalogue a droite pour commencer.
          </div>
        </div>
      </div>

      <div
        v-for="(item, index) in safeItems"
        :key="`${item.id}-${index}`"
        class="devisLineCard"
        :class="{ 'devisLineCard-valid': item.isValide }"
      >
        <div class="devisLineTop">
          <div class="devisLineIdentity">
            <div class="devisLineThumb">
              <img :src="getTof(item.pic)" alt="" />
            </div>
            <div class="devisLineText">
              <div class="devisLineMeta">
                <span class="devisLineType">{{ getLineTypeLabel(item.type) }}</span>
                <span class="devisLineRef">{{ item.ref || "Sans reference" }}</span>
              </div>
              <div class="devisLineName">{{ item.name || "Ligne sans designation" }}</div>
            </div>
          </div>

          <div class="devisLineActions">
            <button
              type="button"
              class="devisActionBtn devisActionBtn-info"
              title="Afficher le détail"
              @click="$emit('showProdInfo', item.id)"
            >
              <b-icon icon="info-circle-fill" aria-hidden="true"></b-icon>
            </button>
            <button
              type="button"
              class="devisActionBtn"
              :class="item.isValide ? 'devisActionBtn-valid' : 'devisActionBtn-muted'"
              :title="item.isValide ? 'Marquer non valide' : 'Marquer valide'"
              @click="toggleValidation(item)"
            >
              <b-icon
                :icon="item.isValide ? 'check-circle-fill' : 'circle'"
                aria-hidden="true"
              ></b-icon>
            </button>
            <button
              type="button"
              class="devisActionBtn devisActionBtn-danger"
              title="Supprimer la ligne"
              @click="RemoveFromBasket(item.id)"
            >
              <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
            </button>
          </div>
        </div>

        <div class="devisLineBody">
          <div class="devisField">
            <label>Quantité</label>
            <base-input
              placeholder="Quantité"
              v-model="item.qte"
              type="num"
              :range="{ min: 1 }"
              :error="errorCtrl"
            >
            </base-input>
          </div>

          <div class="devisField">
            <label>Remise %</label>
            <base-input
              placeholder="Remise"
              v-model="item.remise"
              type="num"
              :range="{ min: 0, max: 100 }"
              :error="errorCtrl"
            >
            </base-input>
          </div>

          <div class="devisField">
            <label>Prix unitaire</label>
            <base-input
              placeholder="Prix"
              v-model="item.prix"
              type="num"
              :range="{ min: 0 }"
              :error="errorCtrl"
            >
            </base-input>
          </div>

          <div class="devisField devisField-total">
            <label>Total ligne</label>
            <div class="devisLineTotal">{{ formatAmount(getLineTotal(item)) }}</div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
  export default {
    components: {},
    props: {
        __object: {
        type: Object,
        default: () => {
          return {};
        },
      },
      __infoProdID: {
        type: String,
        default: () => {
          return "";
        },
      },
      __isOnLoad: {
        type: Boolean,
        default: () => {
          return false;
        },
      },
    },

    data() {
      return {
        onGoingReq: [],
        errorCtrl: []
      };
    },
    methods: {
      getTof(c) {
        return this.__.resolveMediaPath(c, "uploads/catalogue/No-Image.jpg");
      },
      getLineTypeLabel(type) {
        return type === "SRV" ? "Service" : "Produit";
      },
      toggleValidation(item) {
        item.isValide = !item.isValide;
      },
      getLineTotal(item) {
        const qte = Number(item.qte || 0);
        const prix = Number(item.prix || 0);
        const remise = Number(item.remise || 0);
        const total = qte * prix * (1 - remise / 100);
        return Number.isFinite(total) ? total : 0;
      },
      formatAmount(value) {
        const amount = Number(value || 0);
        return `${amount.toFixed(3)} HT`;
      },

      RemoveFromBasket(id) {
        this.$props.__object.devis = this.$props.__object.devis.filter((e) => e.id !== id);
    },
    },
    watch: {
      __isOnLoad: function () {},
    },
    computed: {
      safeItems() {
        return Array.isArray(this.__object.devis) ? this.__object.devis : [];
      },
      lineCountLabel() {
        const count = this.safeItems.length;
        return `${count} ligne${count > 1 ? "s" : ""}`;
      },
    },
    mounted() {
    },
  };
</script>
<style scoped>
.devisLinesShell {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.devisLinesHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.devisLinesEyebrow {
  margin-bottom: 6px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.devisLinesTitle {
  color: #1e2a44;
  font-size: 20px;
  font-weight: 700;
}

.devisLinesCount {
  padding: 8px 14px;
  border-radius: 999px;
  background: #e8eef7;
  color: #32425f;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.devisEmptyState {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px;
  border-radius: 18px;
  background: linear-gradient(180deg, #fbfdff 0%, #f3f7fb 100%);
  border: 1px dashed #c9d7e8;
  color: #64748b;
}

.devisEmptyTitle {
  color: #1e2a44;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
}

.devisEmptyText {
  font-size: 13px;
  line-height: 1.5;
}

.devisLineCard {
  padding: 16px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
  border: 1px solid #dce6f2;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.08);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.devisLineCard:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.12);
}

.devisLineCard-valid {
  border-color: #9dd7b4;
  box-shadow: 0 16px 32px rgba(22, 163, 74, 0.12);
}

.devisLineTop {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 14px;
}

.devisLineIdentity {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.devisLineThumb {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dde7f2;
  flex: 0 0 auto;
}

.devisLineThumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.devisLineText {
  min-width: 0;
}

.devisLineMeta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 6px;
}

.devisLineType {
  padding: 4px 8px;
  border-radius: 999px;
  background: #e8eef7;
  color: #32425f;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.devisLineRef {
  color: #71829c;
  font-size: 12px;
  line-height: 1.4;
}

.devisLineName {
  color: #1e2a44;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.35;
}

.devisLineActions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.devisActionBtn {
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef3f8;
  color: #3b4b68;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}

.devisActionBtn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.12);
}

.devisActionBtn-info {
  background: #e6f0ff;
  color: #2458b8;
}

.devisActionBtn-valid {
  background: #e7f8ee;
  color: #138a42;
}

.devisActionBtn-muted {
  background: #f1f5f9;
  color: #94a3b8;
}

.devisActionBtn-danger {
  background: #fff1f2;
  color: #dc2626;
}

.devisLineBody {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.devisField label {
  display: block;
  margin-bottom: 8px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.devisField :deep(.form-control) {
  min-height: 46px;
  border-radius: 14px;
  border-color: #dbe4f0;
  box-shadow: none;
}

.devisField-total {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.devisLineTotal {
  min-height: 46px;
  padding: 12px 14px;
  border-radius: 14px;
  background: linear-gradient(180deg, #eff6ff 0%, #e4eefb 100%);
  border: 1px solid #cfe0f5;
  color: #1e2a44;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
}

@media (max-width: 991px) {
  .devisLineBody {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .devisLinesHeader,
  .devisLineTop {
    align-items: flex-start;
    flex-direction: column;
  }

  .devisLineActions {
    width: 100%;
  }

  .devisActionBtn {
    width: 40px;
    height: 40px;
  }

  .devisLineBody {
    grid-template-columns: 1fr;
  }

  .devisLineThumb {
    width: 56px;
    height: 56px;
  }
}
</style>
